import { useCallback } from 'react';

import type { UpdateUnderwriterEmployeeInput } from '../../../../../../graphql';
import {
  useSalesCoverage_AdminUpdateUnderwriterEmployeeStatusMutation,
  useSalesCoverage_UpdateUnderwriterEmployeeStatusMutation,
} from '../graphql/__generated__';

export function useUpdateUnderwriterEmployeeStatus(tenantId?: string) {
  const [updateUnderwriterEmployeeStatusAsCustomer, { loading: loadingAsCustomer }] =
    useSalesCoverage_UpdateUnderwriterEmployeeStatusMutation();

  const [updateUnderwriterEmployeeStatusAsAdmin, { loading: loadingAsAdmin }] =
    useSalesCoverage_AdminUpdateUnderwriterEmployeeStatusMutation();

  const updateUnderwriterEmployeeStatus = useCallback(
    async (input: UpdateUnderwriterEmployeeInput) => {
      if (tenantId) {
        return await updateUnderwriterEmployeeStatusAsAdmin({
          variables: {
            input: {
              tenantId,
              ...input,
            },
          },
        });
      } else {
        return await updateUnderwriterEmployeeStatusAsCustomer({
          variables: {
            input,
          },
        });
      }
    },
    [tenantId, updateUnderwriterEmployeeStatusAsAdmin, updateUnderwriterEmployeeStatusAsCustomer]
  );

  return {
    updateUnderwriterEmployeeStatus,
    loading: tenantId ? loadingAsAdmin : loadingAsCustomer,
  };
}
